/**
 * Баллы за игру. Значения — по клубной таблице; начисляются движком по ходу партии
 * (журнал state.scores) и сохраняются в итоги и рейтинг.
 */
export const SCORE_POINTS = {
  /** Мафиози, чей ночной голос привёл к гибели игрока (игроков). */
  MAFIA_KILL_VOTE: 2,
  /** Шериф проверил игрока и нашёл мафию (или дона). */
  SHERIFF_FOUND_MAFIA: 5,
  /** Штраф: шериф проверил мирного. */
  SHERIFF_MISS: -1,
  /** Доктор вылечил именно того, в кого стреляла мафия. */
  DOCTOR_SAVE: 4,
  /** Штраф: доктор лечил сам себя. */
  DOCTOR_SELF_HEAL: -1,
  /** Мирный житель без роли пережил раунд (ночь + день). */
  CIVILIAN_SURVIVED_ROUND: 2,
  /** Команда победила: живым. */
  TEAM_WIN_ALIVE: 6,
  /** Команда победила: погибшим. */
  TEAM_WIN_DEAD: 3,
  /** Игрок убит мафией в 1-м или 2-м раунде (компенсация за раннюю смерть). */
  EARLY_MAFIA_VICTIM: 3,
} as const;

export type ScoreReason = keyof typeof SCORE_POINTS;

export const SCORE_LABELS: Record<ScoreReason, string> = {
  MAFIA_KILL_VOTE: 'Голос мафии, убивший игрока',
  SHERIFF_FOUND_MAFIA: 'Шериф раскрыл мафию',
  SHERIFF_MISS: 'Ошибка шерифа',
  DOCTOR_SAVE: 'Доктор угадал цель мафии',
  DOCTOR_SELF_HEAL: 'Доктор лечил себя',
  CIVILIAN_SURVIVED_ROUND: 'Мирный пережил раунд',
  TEAM_WIN_ALIVE: 'Победа команды (жив)',
  TEAM_WIN_DEAD: 'Победа команды (погиб)',
  EARLY_MAFIA_VICTIM: 'Убит мафией в 1–2 раунде',
};

export interface ScoreEntry {
  seat: number;
  reason: ScoreReason;
  points: number;
  day: number;
}

/** Суммы по местам. */
export function totalsBySeat(entries: readonly ScoreEntry[]): Map<number, number> {
  const totals = new Map<number, number>();
  for (const e of entries) totals.set(e.seat, (totals.get(e.seat) ?? 0) + e.points);
  return totals;
}
